import { useMemo } from 'react';
import { useQuery } from '@ts-core/lib/apollo';

import { getDocumentsByCourseQuery } from '../graphql/queries';

export default function useCourseDocuments({ courseId }) {
  const { data, loading } = useQuery(getDocumentsByCourseQuery, {
    variables: { courseId },
    skip: !courseId,
    fetchPolicy: 'no-cache',
  });
  const documents = useMemo(() => data?.documents || [], [data]);

  return {
    documents,
    loading,
  };
}
